<div class="d-flex align-items-center">
  <div>
    <a href="https://www.facebook.com/abocamuseum.it"
      class="d-flex align-items-center">
      <img src="/assets/icons/FacebookLogo.svg"
        alt="Visit our Facebook page"
        class="social-icon" />
    </a>
  </div>
  <div class="ml-4">
    <a href="https://www.instagram.com/aboca_museum/"
      class="d-flex align-items-center">
      <img src="/assets/icons/InstagramLogo.svg"
        alt="Visit our Instagram page"
        class="social-icon" />
    </a>
  </div>
  <div class="ml-4">
    <a href="https://www.youtube.com/user/aboca09?feature=watch"
      class="d-flex align-items-center">
      <img src="/assets/icons/YoutubeLogo.svg"
        alt="Visit our YouTube channel"
        class="social-icon" />
    </a>
  </div>
  <div class="ml-4">
    <a href="https://www.tripadvisor.it/Attraction_Review-g194903-d1598823-Reviews-Aboca_Museum-Sansepolcro_Province_of_Arezzo_Tuscany.html"
      class="d-flex align-items-center">
      <img src="/assets/icons/TripadvisorLogo.svg"
        alt="Visit our TripAdvisor page"
        class="social-icon" />
    </a>
  </div>
  <!-- 
    <ng-container *ngIf="bitfDynamicLocaleService?.locale?.code === 'it'">
      <a href="https://apps.apple.com/it/app/aboca-museum/id1591421116">
        <button mat-flat-button
          class="social-icon appstore">
        </button>
      </a>

      <a
        href="https://play.google.com/store/apps/details?id=it.itcares.pharo.abocamuseum&hl=it&gl=US&pli=1">
        <button mat-flat-button
          class="social-icon playstore">
        </button>
      </a>
    </ng-container>

    <button mat-flat-button
      class="lang-icon it"
      (click)="onChangeLanguage('it')"></button>

    <button mat-flat-button
      class="lang-icon en"
      (click)="onChangeLanguage('en')"></button> -->

</div>